import { formatRelative } from "date-fns";
import { getDateFnsLocale } from "components/i18nResources";

export const formatRelativeDate = (date: Date): string =>
  formatRelative(date, new Date(), { locale: getDateFnsLocale() });
